<template>
  <div>
    <custom-page-table
      ref="table2"
      rowKey="adjustmentId"
      :columns="columns"
      :requestPromise="loadPromise"
    >
  <span slot="adjustmentType" slot-scope="rowItem">
    {{ rowItem.text|getAccountRegulationTypeName }}
  </span>
    </custom-page-table>
  </div>
</template>

<script>
export default {
  name: 'AdjustComponent',
  data() {
    return {
      statementId: '',
      loadPromise: params => this.getAdjustData(params),
      columns: [
        {
          title: '调账时间',
          dataIndex: 'createTime'
        },
        {
          title: '调账原因',
          dataIndex: 'adjustmentReason'
        },
        {
          title: '调账人',
          dataIndex: 'adjuster'
        },
        {
          title: '调账类别',
          dataIndex: 'adjustmentType',
          scopedSlots: { customRender: 'adjustmentType' }
        },
        {
          title: '调账金额(元)',
          dataIndex: 'adjustmentAmount'
        }
      ]
    }
  },
  methods: {
    getAdjustData(params) {
      this.statementId = this.$route.query.statementId
      return this.getHttpServices().getUserService().post('api/v2/financialTransactionr/billingAdjustmentDetails', {
        limitDto: params,
        statementId: this.statementId
      })
    }
  }
}
</script>
<style scoped>
</style>
